import {
    Box,
    Button,
    Theme,
    Typography
} from "@mui/material";
import {
    GetOrderPreviewResponseBody,
    InitiatePaymentResponseBody
} from "../../redux-store/types/cart";
import { MandateCreation } from "../../redux-store/types/investorProfile";
import { useHistory } from "react-router";
import { initiatePayment } from "../../redux-store/actions/cart";
import { useDispatch } from "react-redux";
import { showError } from "../../redux-store/actions/auth";
import { useState } from "react";
import { LoadingButton } from "@mui/lab";
import { BANK_SUB_ACCOUNT_TYPES, PAYMENT_LOOPBACK_URL } from "../../utils/constant";

interface RouterStateData {
    token: string
    cartId: string
}

export default function NetBanking({
    bankDetailsData,
    orderPreviewData

}: {
    bankDetailsData: MandateCreation[];
    orderPreviewData: GetOrderPreviewResponseBody
}): JSX.Element {
    const dispatch = useDispatch()
    const history = useHistory();
    const routerStateObj = history.location.state as RouterStateData
    const [initiatePaymentLoading, setInitiatePaymentLoading] = useState<boolean>(false)
    const [selectedBankDetails, setSelectedBankDetails] = useState<MandateCreation>({} as MandateCreation)

    const handlePayment = async (selectedBankObj: MandateCreation) => {
        setSelectedBankDetails(selectedBankObj)

        const payment = {
            cartId: routerStateObj?.cartId ?? "",
            token: routerStateObj?.token ?? "",
            vpaid: "",
            paymentMode: "DIRECT",
            accountNumber: selectedBankObj?.bankAccountNumber ?? "",
            bankName: selectedBankObj?.bankName ?? "",
            ifsc: selectedBankObj?.ifscCode ?? "",
            loopbackURL: PAYMENT_LOOPBACK_URL,
            accountType: selectedBankObj?.bankAccountType ?? ""
        }

        try {
            setInitiatePaymentLoading(true);
            const response = await (dispatch(initiatePayment(payment)) as unknown as Promise<InitiatePaymentResponseBody>)
            if (!response?.isSuccess) {
                dispatch(showError(response?.response ?? ""))
            }
            else {
                const bsePayment = window.open("", "_self");
                const html = response?.response;
                bsePayment?.document.write(html);
            }
        } catch (e) {
            console.log('error', e);
        } finally {
            setInitiatePaymentLoading(false);
        }
    }

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                rowGap: "35px"
            }}
        >
            {bankDetailsData?.map(obj => (
                <Box key={`${obj?.bankAccountNumber}-${obj?.bankName}`}>
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center"
                        }}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                columnGap: "15px",
                                alignItems: "center",
                            }}
                        >
                            <Box
                                component="img"
                                src="/images/amcIcons/default.svg"
                                sx={{
                                    width: '40px',
                                    height: '40px',
                                    borderRadius: '8px',
                                    objectFit: "contain"
                                }}
                                alt={obj?.bankName}
                            />
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    rowGap: "5px"
                                }}
                            >
                                <Typography
                                    variant="body_500"
                                    sx={(theme: Theme) => ({
                                        fontWeight: 600,
                                        color: theme.palette.text.primary,
                                        lineHeight: "22.5px",
                                        letterSpacing: "0.02px"
                                    })}
                                >
                                    {obj?.bankAccountNumber ?? "-"}
                                </Typography>
                                <Typography
                                    variant="body_500"
                                    sx={(theme: Theme) => ({
                                        color: theme.palette.text.secondary,
                                        lineHeight: "22.5px",
                                        letterSpacing: "0.02px"
                                    })}
                                >
                                    Linked Bank Account
                                </Typography>
                            </Box>
                        </Box>
                        <LoadingButton
                            loading={(initiatePaymentLoading && selectedBankDetails?.bankAccountNumber === obj?.bankAccountNumber)}
                            loadingPosition="center"
                            disabled={
                                (initiatePaymentLoading && selectedBankDetails?.bankAccountNumber !== obj?.bankAccountNumber) ||
                                !orderPreviewData?.payable_amount
                            }
                            variant="contained"
                            sx={(theme: Theme) => ({
                                ...theme.typography.body_500,
                                fontWeight: 700,
                                lineHeight: "22.5px",
                                letterSpacing: "0.02px",
                                color: theme.palette.textDark.primary,
                                borderRadius: "10px",
                                padding: "13px 56px",
                                boxShadow: "none",
                                backgroundColor: theme.palette.primary[500],
                            })}
                            onClick={() => handlePayment(obj)}
                        >
                            PAY USING THIS ACCOUNT
                        </LoadingButton>
                    </Box>
                    <Typography
                        variant="body_500"
                        sx={(theme: Theme) => ({
                            marginTop: "15px",
                            color: theme.palette.text.secondary,
                            lineHeight: "22.5px",
                            letterSpacing: "0.02px"
                        })}
                    >
                        Please enter details of your Account {obj?.bankAccountNumber ?? "-"} (Sub Account Type: {BANK_SUB_ACCOUNT_TYPES[`${obj?.bankSubAccountType ?? ""}`.toUpperCase()] ?? "-"}) to make Payment
                    </Typography>
                </Box>
            ))}
        </Box>
    )
}
